import { render } from "./YouTubeFullscreen.vue?vue&type=template&id=79a86a24&scoped=true&ts=true"
import script from "./YouTubeFullscreen.vue?vue&type=script&lang=ts"
export * from "./YouTubeFullscreen.vue?vue&type=script&lang=ts"

import "./YouTubeFullscreen.vue?vue&type=style&index=0&id=79a86a24&lang=scss&scoped=true"
import "./YouTubeFullscreen.vue?vue&type=style&index=1&id=79a86a24&lang=scss"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a86a24"]])

export default __exports__